import {v4} from 'uuid';
import { getHeaders } from "../utils";

export async function APIGetMapsDetailsIntegration(accessId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);


        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/public/1.0/integration/maps/${accessId}`, requestOptions);
        const responseObject = await response.json();
        const mapDetails = responseObject;

        if(typeof mapDetails !== "undefined") {
            return mapDetails;
        } else {
            return null;
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APIGetMapsDetails(mapId, companyId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };


        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/private/1.0/customer/${companyId}/maps/${mapId}`, requestOptions);
        const responseObject = await response.json();
        const mapDetails = responseObject;

        if(typeof mapDetails !== "undefined") {
            return mapDetails;
        } else {
            return null;
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APIGetMapsDetailsData(mapId, companyId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/private/1.0/customer/${companyId}/maps/${mapId}/data`, requestOptions);
        const responseObject = await response.json();
        const mapDetailsData = responseObject;

        if(typeof mapDetailsData?.[0] !== "undefined") {
            return mapDetailsData?.[0] ;
        } else {
            return null;
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APIPutMapsName(mapId, name, companyId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const requestOptions = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify({name: name}),
            redirect: 'follow',
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/private/1.0/customer/${companyId}/maps/${mapId}`, requestOptions);
        const responseObject = await response.json();
        const mapDetailsData = responseObject.data;

        if(typeof mapDetailsData?.[0] !== "undefined") {
            return mapDetailsData?.[0] ;
        } else {
            return null;
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APIGetMyMaps(companyId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow'
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/map/1.0/company/${companyId}/maps/all`, requestOptions);
        const responseObject = await response.json();
        const maps = responseObject?.data;


        if(maps.length > 0) {
            return maps;
        } else {
            return [];
        }

    } catch (error) {
        //console.error('Error:', error);
        //throw error;
    }
}

export async function APIDeleteMap(id, companyId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const requestOptions = {
            method: 'DELETE',
            headers: headers,
            redirect: 'follow'
        };

        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/map/1.0/company/${companyId}/map/${id}`, requestOptions);
        const responseObject = await response.json();
        const data = responseObject?.data;

        if(data.length > 0) {
            return await data;
        } else {
            return null;
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APICreateMyMap(user) {
    try {
        const companyId = user?.companyId;
        const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

        const id = v4();
        const raw = JSON.stringify({
            id: id,
            accessId: v4(),
            createdByCompany: user?.companyId,
            createdByUser: user?.id,
            updatedByUser: user?.id,
            name: "Meine Karte",
            url: "https://widget.xplanung24.de/map/"+id,
            createdAt: Date.now(),
            updatedAt: Date.now(),
        });

        const requestOptions = {
            method: 'POST',
            headers: headers,
            body: raw,
            redirect: 'follow'
        };


        // Use template literals to construct the URL
        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        await fetch(`${apiUrl}/map/1.0/company/${companyId}`, requestOptions);

        if(id) {
            return id;
        } else {
            return null;
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export async function APIUpdateMapPlans(plans,mapId,companyId) {
    try {
        const headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);

        const raw = JSON.stringify({
            plans: plans
        });

        const requestOptions = {
            method: 'PUT',
            headers: headers,
            body: raw,
            redirect: 'follow'
        };

        const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_EXTERNAL_PRODUCTION : process.env.REACT_APP_API_EXTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/rest/private/1.0/customer/${companyId}/maps/${mapId}/plans/`, requestOptions);
        const responseObject = await response.json();

        if (responseObject.ok) {
            return true;
        } else {
            console.error('Error:', responseObject.message);
            return null;
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}